import { mockPharmacyDB } from './mockDb';
import type { Supplier, SupplierFormData } from '../types';

export const supplierService = {
  async getAll(): Promise<Supplier[]> {
    return mockPharmacyDB.getSuppliers();
  },

  async getById(id: string): Promise<Supplier | null> {
    const supplier = mockPharmacyDB.getSupplier(id);
    return supplier || null;
  },

  async create(data: SupplierFormData): Promise<Supplier> {
    return mockPharmacyDB.createSupplier(data);
  },

  async update(id: string, data: Partial<SupplierFormData>): Promise<Supplier | null> {
    return mockPharmacyDB.updateSupplier(id, data);
  },

  async getActiveOnly(): Promise<Supplier[]> {
    const suppliers = await this.getAll();
    return suppliers.filter(s => s.status === 'active');
  }
};
